import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../../../../../../../common/types/dispatch';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../../selectors/analytics';
import { preparePackages } from '../utils';
import { trackPackageSelect } from '../tracking';
import { selectPackage } from '../../../../../../../actions/publishTerms';
import { loadPublishTerms } from '../../../../../../../thunks/publishTerms/loadPublishTerms';
import { IUsePackages } from './types';
import { selectActivePackageId, selectPackages } from '../../../../../../../reducers/v2/publicationPackages/selectors';

export const usePackages = (): IUsePackages => {
  const dispatch = useDispatch<TDispatch>();
  const packages = useSelector(selectPackages);
  const activePackageId = useSelector(selectActivePackageId);

  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);

  const preparedPackages = useMemo(() => preparePackages(packages), [packages]);

  const handleChangePackage = useCallback(
    (newPackageId: string) => {
      const packageServiceId = packages.find(({ id }) => id === newPackageId)!.serviceId;

      trackPackageSelect({ analyticsOfferStatus, analyticsProduct, packageServiceId });

      dispatch(selectPackage(newPackageId));

      dispatch(loadPublishTerms({ isServicesReload: true }));
    },
    [analyticsOfferStatus, analyticsProduct, dispatch, packages],
  );

  return {
    selectedPackageId: activePackageId,
    packages: preparedPackages,
    onChange: handleChangePackage,
  };
};
